import React from "react";

import { Box, Drawer, useTheme } from "@mui/material";

import { MINI_DRAWER_WIDTH } from "../constants";

import SidebarHeader from "./SidebarHeader";
import SidebarNavigation from "./SidebarNavigation";

const TOPBAR_HEIGHT = 56;

interface SidebarProps {
  open: boolean;
  visible: boolean;
  width: number;
  isMobile: boolean;
  onClose: () => void;
  onToggle?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({
  open,
  visible,
  width,
  isMobile,
  onClose,
  onToggle,
}) => {
  const theme = useTheme();

  if (!visible) return null;

  return (
    <Drawer
      variant={isMobile ? "temporary" : "permanent"}
      open={isMobile ? open : true}
      onClose={onClose}
      sx={{
        width: open ? width : MINI_DRAWER_WIDTH,
        flexShrink: 0,
        transition: theme.transitions.create("width", {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.standard,
        }),
        "& .MuiDrawer-paper": {
          width: open ? width : MINI_DRAWER_WIDTH,
          boxSizing: "border-box",
          bgcolor: "background.paper",
          borderRight: `1px solid ${theme.palette.divider}`,
          zIndex: 100,
          top: isMobile ? 0 : `${TOPBAR_HEIGHT}px`,
          height: isMobile ? "100%" : `calc(100% - ${TOPBAR_HEIGHT}px)`,
          transition: theme.transitions.create(["width", "transform"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.standard,
          }),
          overflowX: "hidden",
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          backdropFilter: "blur(4px)",
        },
      }}
    >
      <Box
        sx={{
          width: open ? width : MINI_DRAWER_WIDTH,
          height: "100%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.standard,
          }),
        }}
      >
        <SidebarHeader
          collapsed={!open}
          onToggle={isMobile ? undefined : onToggle}
        />
        <SidebarNavigation collapsed={!open} />
      </Box>
    </Drawer>
  );
};

export default Sidebar;
